import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Workflow, EMPTY_ITEM, AdapterPropName, makeDatasource } from 'vscroll';
const _c0 = ["ui-scroll", ""];
const _c1 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  index: a1,
  odd: a2,
  even: a3
});
function UiScrollComponent_div_1_ng_template_1_Template(rf, ctx) {}
function UiScrollComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, UiScrollComponent_div_1_ng_template_1_Template, 0, 0, "ng-template", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("position", item_r1.invisible ? "fixed" : null)("left", item_r1.invisible ? "-99999px" : null);
    i0.ɵɵattribute("data-sid", item_r1.$index);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.template)("ngTemplateOutletContext", i0.ɵɵpureFunction4(7, _c1, item_r1.data, item_r1.$index, item_r1.$index % 2, !(item_r1.$index % 2)));
  }
}
export { Routines, SizeStrategy } from 'vscroll';
import { Subject, BehaviorSubject } from 'rxjs';
var consumer = {
  name: 'ngx-ui-scroll',
  version: '3.2.2'
};
let UiScrollComponent = /*#__PURE__*/(() => {
  class UiScrollComponent {
    constructor(changeDetector, elementRef, ngZone) {
      this.changeDetector = changeDetector;
      this.elementRef = elementRef;
      this.ngZone = ngZone;
      // the only template variable
      this.items = [];
    }
    ngOnInit() {
      // The workflow should be created outside of the Angular zone because it's causing many
      // change detection cycles. It runs its `init()` function in a `setTimeout` task, which
      // then sets up the `scroll` listener. The `scroll` event listener would force Angular to
      // run `tick()` any time the `scroll` task is invoked. We don't care about `scroll` events
      // since they're handled internally by `vscroll`. We still run change detection manually
      // tho when the `run` function is invoked.
      // `scroll` events may be also unpatched through zone.js flags:
      // `(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll']`.
      // Having `runOutsideAngular` guarantees we're responsible for running change detection
      // only when it's "required" (when `items` are updated and the template should be updated too).
      this.workflow = this.ngZone.runOutsideAngular(() => new Workflow(Object.assign({
        consumer,
        element: this.elementRef.nativeElement,
        datasource: this.datasource,
        run: items => {
          if (!items.length && !this.items.length) {
            return;
          }
          // Re-enter the Angular zone only when items are set and when we have to run the local change detection.
          this.ngZone.run(() => {
            this.items = items;
            this.changeDetector.detectChanges();
          });
        }
      }, this.Routines ? {
        Routines: this.Routines
      } : {})));
    }
    ngOnDestroy() {
      var _a;
      (_a = this.workflow) === null || _a === void 0 ? void 0 : _a.dispose();
    }
  }
  UiScrollComponent.ɵfac = function UiScrollComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UiScrollComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  UiScrollComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: UiScrollComponent,
    selectors: [["", "ui-scroll", ""]],
    standalone: false,
    attrs: _c0,
    decls: 3,
    vars: 1,
    consts: [["data-padding-backward", ""], [3, "position", "left", 4, "ngFor", "ngForOf"], ["data-padding-forward", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
    template: function UiScrollComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵtemplate(1, UiScrollComponent_div_1_Template, 2, 12, "div", 1);
        i0.ɵɵelement(2, "div", 2);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.items);
      }
    },
    dependencies: [i1.NgForOf, i1.NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
  return UiScrollComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UiScrollDirective = /*#__PURE__*/(() => {
  class UiScrollDirective {
    constructor(templateRef, viewContainer) {
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
    }
    set uiScrollOf(datasource) {
      this.datasource = datasource;
    }
    set uiScrollRoutines(Routines) {
      this.Routines = Routines;
    }
    ngOnInit() {
      const componentRef = this.viewContainer.createComponent(UiScrollComponent);
      componentRef.instance.datasource = this.datasource;
      componentRef.instance.template = this.templateRef;
      componentRef.instance.Routines = this.Routines;
    }
  }
  UiScrollDirective.ɵfac = function UiScrollDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UiScrollDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  UiScrollDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: UiScrollDirective,
    selectors: [["", "uiScroll", "", "uiScrollOf", ""]],
    inputs: {
      uiScrollOf: "uiScrollOf",
      uiScrollRoutines: "uiScrollRoutines"
    },
    standalone: false
  });
  return UiScrollDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UiScrollModule = /*#__PURE__*/(() => {
  class UiScrollModule {}
  UiScrollModule.ɵfac = function UiScrollModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UiScrollModule)();
  };
  UiScrollModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: UiScrollModule
  });
  UiScrollModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return UiScrollModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const getBooleanSubjectPropConfig = () => ({
  source: new Subject(),
  emit: (source, value) => source.next(value)
});
const getItemBehaviorSubjectPropConfig = () => ({
  source: new BehaviorSubject(EMPTY_ITEM),
  emit: (source, value) => source.next(value)
});
const getAdapterConfig = () => ({
  mock: false,
  reactive: {
    [AdapterPropName.init$]: getBooleanSubjectPropConfig(),
    [AdapterPropName.isLoading$]: getBooleanSubjectPropConfig(),
    [AdapterPropName.loopPending$]: getBooleanSubjectPropConfig(),
    [AdapterPropName.firstVisible$]: getItemBehaviorSubjectPropConfig(),
    [AdapterPropName.lastVisible$]: getItemBehaviorSubjectPropConfig(),
    [AdapterPropName.bof$]: getBooleanSubjectPropConfig(),
    [AdapterPropName.eof$]: getBooleanSubjectPropConfig(),
    [AdapterPropName.paused$]: getBooleanSubjectPropConfig()
  }
});
const AngularDatasource = makeDatasource(getAdapterConfig);

/**
 * Generated bundle index. Do not edit.
 */

export { AngularDatasource as Datasource, UiScrollDirective, UiScrollModule };
